import { Helmet } from 'react-helmet-async';

export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "RSA Tech Group",
    "alternateName": "RSA Technology",
    "url": "https://rsatech.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://rsatech.com/rsa-logo.png",
      "width": 400,
      "height": 120
    },
    "image": "https://rsatech.com/rsa-logo.png",
    "description": "RSA Tech Group is the AI holding company behind Connexr and LeoRix AI — building the companies that power the intelligent enterprise.",
    "slogan": "The AI Holding Company.",
    "foundingDate": "2020",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "info@rsatech.com",
      "url": "https://rsatech.com/contact"
    },
    "sameAs": [
      "https://www.linkedin.com/company/rsatech",
      "https://www.instagram.com/rsatech",
      "https://www.youtube.com/@rsatech",
      "https://twitter.com/rsatech",
      "https://www.facebook.com/rsatech"
    ],
    "knowsAbout": [
      "Artificial Intelligence",
      "Machine Learning",
      "Digital Transformation",
      "Enterprise Software",
      "Cloud Computing",
      "Generative AI",
      "AIOps",
      "Cognitive Computing"
    ],
    "areaServed": "Worldwide",
    "serviceType": [
      "AI Transformation & Automation",
      "Managed Services & AIOps",
      "Cloud Infrastructure",
      "Cognitive Enterprise Solutions",
      "Generative AI Solutions"
    ],
    "subOrganization": [
      {
        "@type": "Organization",
        "name": "ConnexR",
        "url": "https://connexr.com",
        "description": "AI-First Managed Services and Enterprise Engineering, a division of RSA Tech Group",
        "parentOrganization": {
          "@type": "Organization",
          "name": "RSA Tech Group",
          "url": "https://rsatech.com"
        }
      }
    ],
    "owns": [
      {
        "@type": "Organization",
        "name": "ConnexR",
        "url": "https://connexr.com"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
